var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrameBig(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1149 84.5999C50.5508 84.5981 49.993 84.4811 49.4763 84.2562C48.9596 84.0314 48.495 83.7034 48.1113 83.2927L28.1148 62.1729C27.3673 61.382 26.9669 60.3286 27.0016 59.2446C27.0363 58.1606 27.5034 57.1346 28.3 56.3925C29.0966 55.6503 30.1575 55.2528 31.2493 55.2872C32.3412 55.3217 33.3745 55.7854 34.122 56.5763L51.0738 74.5098L85.6769 36.9271C86.028 36.493 86.4649 36.1347 86.9606 35.8743C87.4563 35.6138 88.0004 35.4568 88.5595 35.4127C89.1185 35.3687 89.6808 35.4385 90.2116 35.6181C90.7425 35.7976 91.2308 36.083 91.6466 36.4567C92.0623 36.8304 92.3967 37.2846 92.6292 37.7913C92.8617 38.298 92.9875 38.8465 92.9987 39.4032C93.0099 39.96 92.9064 40.5131 92.6945 41.0286C92.4825 41.5441 92.1667 42.0112 91.7664 42.4011L54.1597 83.2518C53.7797 83.67 53.3167 84.0056 52.7998 84.2375C52.2829 84.4695 51.7233 84.5929 51.1561 84.5999H51.1149Z",
    fill: "#1CBB32"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -0.000488281,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#1CBB32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameBig);
export default __webpack_public_path__ + "static/media/Frame_big.b7b47856e7c59032e60d1391bcbce086.svg";
export { ForwardRef as ReactComponent };